<template>
  <div>
    <div class="css-grid battery-order-form__row battery-order-form__row--header battery-order-form__row--success">
      <div></div>
      <div class="battery-order-view__cell battery-order-view__cell--header">Order Received</div>
      <div></div>
    </div>

    <div class="panel">
      <div class="css-grid battery-order-form__row">
        <div></div>
        <div class="battery-order__message battery-order__message--success">
          Thank you. Your order has been received.
        </div>
        <div></div>
      </div>
      <div class="css-grid battery-order-form__row" v-if="paymentType != 'Credit Card'">
        <div></div>
        <div class="battery-order__message battery-order__message--success">
          Fuel will mail you an invoice after order completion.
        </div>
        <div></div>
      </div>
    </div>
    <ProductCartView></ProductCartView>

    <div class="panel battery-store__nav-row h-center-align">
      <button class="btn btn-primary" @click.prevent="nextStep">Create New Order</button>
    </div>
  </div>
</template>

<script>
  import  { mapGetters } from 'vuex';
  import ProductCartView from './products/ProductCartView.vue';

  export default {
    name: 'SuccessMessageView',
    components: {
      ProductCartView,
    },
    computed: {
      ...mapGetters('batteryStore', ['paymentType', 'orderProducts']),
    },
    methods: {
      nextStep() {
        this.$store.dispatch('batteryStore/resetForm');
      },
    },
  }
</script>
